import type { TabNavItem } from '@mercedes-benz/odp-theme-v2';
import { RelationsIcon } from '@mercedes-benz/odp-theme-v2';
import InfoIcon from '@mui/icons-material/Info';
import FeedbackIcon from '@mui/icons-material/Feedback';
import { EntityPageLayout } from './EntityPageLayout';
import { CoreDetailsTab } from '../system-details/CoreDetailsTab';
import { RelationsTab } from '../system-details/RelationsTab';
import { FeedbackTab } from './FeedbackTab';

const TABS: TabNavItem[] = [
  { id: 'overview', label: 'Overview', icon: InfoIcon },
  { id: 'feedback', label: 'Feedback', icon: FeedbackIcon },
  { id: 'relations', label: 'Relations', icon: RelationsIcon },
];

export const SystemRoleEntityPage = () => (
  <EntityPageLayout tabs={TABS}>
    {activeTab => (
      <>
        {activeTab === 'overview' && <CoreDetailsTab />}
        {activeTab === 'feedback' && <FeedbackTab />}
        {activeTab === 'relations' && <RelationsTab />}
      </>
    )}
  </EntityPageLayout>
);
